<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <Button type="primary" icon="ios-add" @click="showDialog"
      >创建银行账户
      </Button>
      <vxe-button
          icon="vxe-icon--refresh"
          @click="refresh"
          :style="
          !isHavePermission('bankAccount:createPlatformCompany:add')
            ? ''
            : 'margin-left: 20px'
        "
      >刷新
      </vxe-button>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          highlight-hover-row
          show-footer
          stripe
          align="center"
          border="none"
          auto-resize
          :data="tableData"
          max-height="540"
          :loading="loading"
      >
        <vxe-table-column field="id" title="序号" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.id }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="accountName" title="户名"></vxe-table-column>
        <vxe-table-column
            field="openBankName"
            title="开户行"
        ></vxe-table-column>
        <vxe-table-column
            field="accountNum"
            title="银行账号"
        ></vxe-table-column>
        <vxe-table-column field="openOrgNum" title="联行号"></vxe-table-column>
        <vxe-table-column title="操作">
          <template slot-scope="{ row }">
            <span
                style="color: #2d8cf0; cursor: pointer; margin-right: 10px"
                @click="openUpdateView(row)"
            >编辑</span
            >
            <span
                style="color: red; cursor: pointer;margin-right: 10px"
                @click="commitDelete(row)"
            >删除</span
            >
            <span
                v-if="row.isDefault == 0"
                style="cursor: pointer; color: #2d8cf0"
                @click="setDefaultBank(row)"
            >设为默认</span
            >
            <span v-if="row.isDefault == 1">默认</span>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <!-- 创建银行账户 -->
    <vxe-modal
        v-model="createAccountModal"
        width="600"
        height="400"
        transfer
        destroy-on-close
    >
      <p slot="header" class="box-tit-211130">
        <span>{{ title }}</span>
      </p>
      <vxe-form
          ref="accountFrom"
          title-align="right"
          title-width="110"
          :data="accountData"
          :rules="formRules2"
          style="margin-top: 20px; padding-right: 50px"
          @submit="submitAccount"
      >
        <vxe-form-item title="户名" field="accountName" span="24">
          <template v-slot="scope">
            <vxe-input
                v-model="accountData.accountName"
                placeholder="请输入户名"
                @input="$refs.accountFrom.updateStatus(scope)"
                style="width: 400px"
            ></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="开户行" field="openBankName" span="24">
          <template v-slot="scope">
            <vxe-pulldown ref="bankDown" transfer style="width: 100%">
              <template v-slot>
                <vxe-input
                    v-model="accountData.openBankName"
                    :placeholder="placeholderTxt"
                    @focus="bankFocusEvent"
                    @keyup="bankKeyupEvent"
                    @blur="checkOrg"
                >
                  <template #suffix>
                    <div class="input-inner-switch">
                      <em>手动输入</em>
                      <vxe-switch
                          v-model="isInputBank"
                          open-label="是"
                          close-label="否"
                      ></vxe-switch>
                    </div>
                  </template>
                </vxe-input>
              </template>
              <template v-slot:dropdown>
                <div class="my-dropdown1">
                  <div
                      class="list-item1"
                      v-for="item in bankList"
                      :key="item.id"
                      @click="bankSelectEvent(item, scope)"
                  >
                    <i class="fa fa-user-o"></i>
                    <span>{{ item.orgName }}</span>
                  </div>
                </div>
              </template>
            </vxe-pulldown>
          </template>
        </vxe-form-item>
        <span class="open-bank-tip"
        ><Icon
            type="ios-information-circle-outline"
        />若未查询到开户行，请切换到手动输入</span
        >
        <!-- <vxe-form-item title="手动输入联行号">
          <template>
            <vxe-switch
              v-model="isInputBank"
              open-label="是"
              close-label="否"
            ></vxe-switch>
          </template>
        </vxe-form-item> -->
        <vxe-form-item
            title="开户行联行号"
            field="openOrgNum"
            span="24"
            v-if="isInputBank"
        >
          <template v-slot="scope">
            <vxe-input
                v-model="accountData.openOrgNum"
                placeholder="输入开户行联行号"
                @input="$refs.accountFrom.updateStatus(scope)"
                style="width: 400px"
                :disabled="!isInputBank"
            ></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="银行账号" field="accountNum" span="24">
          <template v-slot="scope">
            <vxe-input
                v-model="accountData.accountNum"
                placeholder="输入银行账号"
                @input="$refs.accountFrom.updateStatus(scope)"
                style="width: 400px"
            ></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item align="right" span="24" style="margin-top: 20px">
          <vxe-button
              status="primary"
              style="width: 140px; border-radius: 0px"
              @click="cancelSubmit"
          >取消
          </vxe-button>
          <vxe-button
              type="submit"
              status="primary"
              style="width: 140px; border-radius: 0px"
          >保存
          </vxe-button>
        </vxe-form-item>
      </vxe-form>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  name: "BankAccount",
  components: {},
  props: {
    userId: Number,
    realName: String,
    isXcw: {
      type: Boolean,
      default: false
    }
  },
  mixins: [getAuthOrization],
  data() {
    const number = ({itemValue}) => {
      if (itemValue && itemValue !== "") {
        let reg = /^\d+(?=\.{0,1}\d+$|$)/;
        if (!reg.test(itemValue)) {
          return Promise.reject(new Error("请输入正确的数字"));
        }
      }
    };
    return {
      title: "",
      createAccountModal: false,
      accountData: {
        openBankName: "",
        openOrgNum: ""
      },
      commitType: 1,
      visible: false,
      updateVisible: false,
      loading: false,
      tableData: [],
      page: {
        currentPage: 1,
        pageSize: 100,
        totalResult: 100
      },
      formRules2: {
        accountName: [{required: true, message: "请输入户名"}],
        openBankName: [{required: true, message: "请选择开户行"}],
        openOrgNum: [
          {required: true, message: "请输入联行号"},
          {message: "联行号长度错误", min: 12, max: 12}
        ],
        accountNum: [
          {required: true, message: "请输入银行账户号"},
          {validator: number}
        ]
      },
      bankList: [],
      chooseBank: false,
      isInputBank: false, //是否手动输入开户行
      openBankName: null
    };
  },
  watch: {
    isInputBank(newVal, oldVal) {
      // console.log(newVal)
      if (newVal && !this.accountData.openOrgNum) {
        this.accountData.openBankName = this.openBankName;
      }
      if (!newVal && oldVal) {
        this.accountData.openBankName = this.accountData.openOrgNum = this.openBankName =
            "";
      }
    },
    realName(val) {
      if (val) {
        this.accountData.accountName = val;
      }
    }
  },
  computed: {
    placeholderTxt() {
      return this.isInputBank ? "请输入开户行" : "请选择开户行"
    }
  },
  methods: {
    checkOrg() {
      if (
          !this.isInputBank &&
          (!this.accountData.openOrgNum || !this.chooseBank)
      ) {
        this.openBankName = this.accountData.openBankName;
        this.accountData.openBankName = "";
        // this.accountData.openOrgNum = "";
      }
    },
    bankFocusEvent() {
      if (!this.isInputBank) {
        this.$refs.bankDown.showPanel();
      }
    },
    bankKeyupEvent() {
      if (!this.isInputBank) {
        this.chooseBank = false;
        this.getBankListByName();
      }
    },
    bankSelectEvent(obj, scope) {
      this.chooseBank = true;
      this.accountData.openBankName = obj.orgName;
      this.accountData.openOrgNum = obj.orgNum;
      this.$refs.bankDown.hidePanel();
      this.$refs.accountFrom.updateStatus(scope);
    },
    async getBankListByName() {
      let name = this.accountData.openBankName;
      let res = await $api.finance.get(`cebBankOrg/searchOrgByName/${name}`);
      if (res.status === 1) {
        this.bankList = res.data;
      }
    },
    refresh() {
      this.queryUserBankList(this.userId);
    },
    afterSave() {
      this.visible = false;
      this.queryUserBankList(this.userId);
    },
    async setDefaultBank(row) {
      var obj = {
        bankId: row.id,
        userId: this.userId
      };
      let res = await $api.baseUserSignBank.request("setDefaultBank", obj);
      if (res.status === 1) {
        this.$Message.success("操作成功");
        this.queryUserBankList(this.userId);
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    },
    async queryUserBankList(id) {
      this.loading = true;
      this.userId = id;
      let obj = this.isXcw ? {
        userIdClient: id
      } : {
        userId: id
      }
      let res = await $api.baseUserSignBank.request(this.isXcw ? 'queryUserBankListClient' : "queryUserBankList", obj);
      if (res.status === 1) {
        this.tableData = res.data;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
        this.loading = false;
      }
    },
    commitDelete(row) {
      this.$XModal.confirm("您确定要删除吗？").then(type => {
        if (type === "confirm") {
          this.deleteAccount(row);
        }
      });
    },
    async deleteAccount(row) {
      var obj = {id: row.id};
      let res = await $api.baseUserSignBank.request("deleteUserBank", obj);
      if (res.status === 1) {
        this.$Message.success("删除成功");
        this.queryUserBankList(this.userId);
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    },
    close() {
      this.visible = false;
    },
    closeCreate() {
      this.visible = false;
      this.$refs.accountModal.close();
    },
    changePage(e) {
    },
    showDialog() {
      this.accountData = {};
      this.title = "新增银行账户";
      this.commitType = 1;
      if (this.isXcw) {
        this.accountData.userIdClient = this.userId;
      } else {
        this.accountData.signUserId = this.userId;
      }
      this.createAccountModal = true;
    },
    openUpdateView(row) {
      this.title = "修改银行账户";
      this.accountData = JSON.parse(JSON.stringify(row));
      this.accountData.id = row.id;
      this.accountData.openBankName = row.openBankName;
      if (this.isXcw) {
        this.accountData.userIdClient = this.userId;
      } else {
        this.accountData.signUserId = this.userId;
      }
      this.commitType = 2;
      this.createAccountModal = true;
    },
    cancelSubmit() {
      this.isInputBank = false;
      this.createAccountModal = false;
    },
    async submitAccount() {
      let self = this;
      if (this.accountData.accountName) {
        this.accountData.accountName = this.accountData.accountName.trim();
      }
      if (this.accountData.openBankName) {
        this.accountData.openBankName = this.accountData.openBankName.trim();
      }
      if (this.accountData.accountNum) {
        this.accountData.accountNum = this.accountData.accountNum.trim();
      }

      let url = "createUserBank";
      if (this.commitType == 1) {
        url = "createUserBank";
      } else if (this.commitType == 2) {
        url = "updateUserBank";
      }
      let res = await $api.baseUserSignBank
          .request(url, this.accountData)
          .catch(function (er) {
            console.log(er.response.data.message);
            self.$XModal.alert({
              message: er.response.data.message
                  ? er.response.data.message
                  : "接口异常",
              status: "error"
            });
            return;
          });
      if (res.status == 1) {
        this.$Message["success"]({
          background: true,
          content: "更新成功"
        });
        this.isInputBank = false;
        this.createAccountModal = false;
        this.queryUserBankList(this.userId);
      } else {
        this.$emit("closeEdit", false);
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    }
  }
};
</script>

<style>
@import "../../../src/assets/icon/icon-filter/iconfont.css";
@import "../../../src/assets/icon/icon-more/iconfont.css";

.button-gengduo {
  border: none;
}

.button-gengduo:focus {
  outline: none;
  border-color: transparent;
  box-shadow: none;
}

.page-con-header {
  margin-bottom: 10px;
  position: relative;
}

.input-inner-switch {
  width: 100px;
  position: absolute;
  right: 0;
  top: 0;
  height: 34px;
}

.input-inner-switch .vxe-switch {
  position: absolute;
  right: -5px;
  top: 0;
}

.input-inner-switch em {
  font-size: 12px;
  height: 100%;
  line-height: 34px;
  display: inline-block;
  color: #606266;
}

.open-bank-tip {
  display: block;
  color: #f00;
  padding-left: 110px;
}
</style>
